import { render, staticRenderFns } from "./colabVue.vue?vue&type=template&id=cfff88c4&scoped=true"
import script from "./colabVue.vue?vue&type=script&lang=js"
export * from "./colabVue.vue?vue&type=script&lang=js"
import style0 from "./colabVue.vue?vue&type=style&index=0&id=cfff88c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfff88c4",
  null
  
)

export default component.exports